import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap/lib'
import TablesControleResults from './TablesControleResults'


class ControlerenResults extends Component {

    render() {
        return (
            <div className="ControlerenResults">
                <Row>
                    <Col md={12}>
                        <TablesControleResults srch={this.props.srch} />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ControlerenResults;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/ControlerenResults.js